import { withRouter } from 'react-router-dom';

import AuthService from '../../../services/authService';

const Callback: React.FC = (props: any): JSX.Element => {
    return AuthService.loginCallback(props);
};

export default withRouter(Callback);
